enum LanguageCode {
  EN = 'en',
  FR = 'fr',
  NL = 'nl',
}

export default LanguageCode;
